/**
 * Nederlandse urennotatie voor de verlof-schermen (UX-DR14, microcopy-tabel).
 *
 * Uren komen in KWARTIEREN, dus twee decimalen moeten overleven: `1,25 uur`,
 * `0,75 uur minder`. De oudere lokale kopieën in `LeaveRequestSheet.tsx` en
 * `LeaveCorrectionSheet.tsx` ronden op één decimaal af en maken van 1,25 dus
 * "1,3" — die staan bewust ongemoeid (het zijn schermen van eerdere stories),
 * maar nieuw werk gebruikt deze functie zodat de goedkeuringslijst hetzelfde
 * getal toont als het besluit dat de server neemt.
 *
 * Hele getallen krijgen geen decimaal, en een overbodige nul valt weg:
 * `8` → `"8"`, `1,5` → `"1,5"`, `1,25` → `"1,25"`.
 */
export function formatNlUren(uren: number): string {
  const rounded = Math.round(uren * 100) / 100;
  if (Number.isInteger(rounded)) return String(rounded);
  return rounded.toFixed(2).replace(/0$/, '').replace('.', ',');
}
